<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue'
import Card from 'primevue/card'
import FormSection from '@/components/forms/FormSection.vue'
import FormInputText from '@/components/inputs/FormInputText.vue'
import FormTextArea from '@/components/inputs/FormTextArea.vue'
import FormDropdown from '@/components/inputs/FormDropdown.vue'
import { unitOptions } from '@/constants/dimension'

const props = defineProps<{
  values: any
  type: 'add' | 'edit' | 'view'
  onSubmit: () => void
  setErrors: (errors: any) => void
}>()

const isAddPage = computed(() => props.type === 'add')
const isEditPage = computed(() => props.type === 'edit')
const isViewPage = computed(() => props.type === 'view')
</script>

<template>
  <form @submit.prevent="onSubmit" class="border-neutral-200/50 !rounded-t-3xl pb-2">
    <Card>
      <template #content>
        <div>
          <FormSection title="">
            <FormInputText :viewOnly="isViewPage" label="Bay" inputName="bay" id="bay" />
            <div class="flex w-full items-center gap-2">
              <div class="flex flex-col w-full">
                <FormInputText
                  :view-only="isViewPage"
                  label="Length"
                  inputName="lengthValue"
                  id="lengthValue"
                  type="number"
                />
              </div>
              <div class="w-1/4">
                <FormDropdown
                  label="Unit"
                  inputName="lengthUnit"
                  id="lengthUnit"
                  :view-only="isViewPage"
                  :options="unitOptions"
                  optionLabel="label"
                  optionValue="value"
                  type="number"
                />
              </div>
            </div>

            <FormInputText :viewOnly="isViewPage" label="Weight" inputName="weight" id="weight" />

            <FormInputText
              :viewOnly="isViewPage"
              label="Last Edited By"
              inputName="lastEditedBy"
              id="lastEditedBy"
            />
          </FormSection>
        </div>
      </template>
    </Card>
  </form>
</template>
